/* @flow */
import React from 'react'

import './style.css'

export default class Card extends React.Component {
  render() {
    const { header, children } = this.props
    return <div className="card">
      { header }
      { children }
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/Card/index.js